import { useEffect, useState } from 'react';

/**
 * Returns true if the primary input is touch-based.
 * Uses `navigator.maxTouchPoints` (reliable on modern browsers) with a
 * `(pointer: coarse)` media-query cross-check as a fallback.
 *
 * Evaluated once on mount — does not react to changes (devices don't
 * switch input modes at runtime in practice).
 */
export function useTouchDevice(): boolean {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const touch =
      navigator.maxTouchPoints > 0 ||
      window.matchMedia('(pointer: coarse)').matches;
    setIsTouch(touch);
  }, []);

  return isTouch;
}
